import React, { useEffect, useRef, useState } from 'react'

import {
  Typography,
  Button,
  Box,
  Popper,
  Fade,
  Paper,
  TextField,
  CardContent,
  IconButton,
} from '@mui/material'
import { Check } from '@mui/icons-material'
import { blue } from '@mui/material/colors'

function useOutsideAlerter(ref, onClick) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClick()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}

const PastTodayFuture = ({ startDate, endDate, setStartDate, setEndDate }) => {
  const [isDateRangeOpen, setIsDateRangeOpen] = useState(false)

  const today = new Date().toLocaleDateString('sv')

  const [anchorEl, setAnchorEl] = useState(null)

  const todayIsSelected = startDate === endDate

  return (
    <Box>
      <DateRangePicker
        anchorEl={anchorEl}
        open={isDateRangeOpen}
        setOpen={setIsDateRangeOpen}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <Button
        sx={{ border: todayIsSelected ? null : `1px solid ${blue[700]}` }}
        onClick={(e) => {
          setAnchorEl(e.currentTarget)
          setIsDateRangeOpen(true)
        }}
      >
        Date Range
      </Button>
      <Button
        sx={{ border: todayIsSelected ? `1px solid ${blue[700]}` : null }}
        onClick={() => {
          setStartDate(today)
          setEndDate(today)

          setIsDateRangeOpen(false)
        }}
      >
        Today
      </Button>
    </Box>
  )
}

const DateRangePicker = ({
  anchorEl,
  open,
  setOpen,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}) => {
  const ref = useRef(null)

  useOutsideAlerter(ref, () => {
    setOpen(false)
  })

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={'top'}
      transition
      sx={{ zIndex: 1000 }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Box ref={ref}>
            <Paper>
              <CardContent>
                <Typography sx={{ mb: 1 }}>
                  <b>Select a date range to view</b>
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <TextField
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    type='date'
                    fullWidth
                    label='Start'
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin='dense'
                    sx={{ mr: 2 }}
                  ></TextField>
                  <TextField
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value)
                    }}
                    type='date'
                    fullWidth
                    label='End'
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin='dense'
                    sx={{ mr: 1 }}
                  ></TextField>
                  <IconButton onClick={() => setOpen(false)} sx={{ mr: -1 }}>
                    <Check color='primary' />
                  </IconButton>
                </Box>
              </CardContent>
            </Paper>
          </Box>
        </Fade>
      )}
    </Popper>
  )
}

export default PastTodayFuture
